export class AnalyticsData {
  UserID: string;
  UserProfile: string;
  CompanyID: string;
  CompanyUID: string;
  WebApp: string = 'private';
  Service: string;
  PageType: string;
  event: string = 'viewContent';
  Region: string;
  country: string;
  topic: string;
  uri: string;
  DocumentName: string;
  nonAuthorisedAccess: boolean;
  DocumentUniqueNumber: string;
  DocumentInstanceId: string;
  Author: string;
  DocumentType: string;
  source: string;
  partialAuth: boolean;
  errorStatus: number;
  token: string;
  apiUrl: string;
  timestamp: string;
  transactionId: string;
  //search related
  query: string;
  resultCount: number;
  currentPage: number;
  fromTo: string;
  searchSort: string;
  navigationListType: string;
  widgetName: string;
  tabName: string;
  responseTime: number;
  audioTitle: string;
  audioPlayerAction: string;
  audioValue: number;
  filterName: string;
  filterValue: string;
  trainingId: number;
  step: string;
  stepName: string;
  traffic_type: string;
  module: string;
  menu_level_1: string;
  menu_level_2: string;
  menu_level_3: string;

  constructor() {}

  toJson() {
    return {
      UserID: this.UserID,
      UserProfile: this.UserProfile,
      CompanyID: this.CompanyID,
      CompanyUID: this.CompanyUID,
      WebApp: this.WebApp,
      Service: this.Service,
      PageType: this.PageType,
      event: this.event,
      Region: this.Region,
      Country: this.country,
      Topic: this.topic,
      Uri: this.uri,
      DocumentName: this.DocumentName,
      DocumentUniqueNumber: this.DocumentUniqueNumber,
      DocumentInstanceId: this.DocumentInstanceId,
      DocumentType: this.DocumentType,
      Author: this.Author,
      nonAuthorisedAccess: this.nonAuthorisedAccess,
      source: this.source,
      partialAuth: this.partialAuth,
      errorStatus: this.errorStatus,
      token: this.token,
      apiUrl: this.apiUrl,
      timestamp: this.timestamp,
      QueryTerms: this.query,
      ResultCount: this.resultCount,
      Page: this.currentPage,
      FromTo: this.fromTo,
      SearchSort: this.searchSort,
      NavigationListType: this.navigationListType,
      widgetName: this.widgetName,
      tabName: this.tabName,
      responseTime: this.responseTime,
      transactionId: this.transactionId,
      audioTitle: this.audioTitle,
      audioPlayerAction: this.audioPlayerAction,
      audioValue: this.audioValue,
      filterName: this.filterName,
      filterValue: this.filterValue,
      trainingId: this.trainingId,
      step: this.step,
      stepName: this.stepName,
      traffic_type: this.traffic_type,
      module: this.module,
      menu_level_1: this.menu_level_1,
      menu_level_2: this.menu_level_2,
      menu_level_3: this.menu_level_3,
    };
  }
}
